export default __webpack_public_path__ + "static/media/Img3.b200147f.jpg";